
import React from 'react';
import { X, RefreshCw, Download } from 'lucide-react';
import { Button } from './ui/button';
import { useUpdateManager } from '@/hooks/useUpdateManager';
import { cn } from '@/lib/utils';

export const UpdateNotification = () => {
  const { 
    isUpdateAvailable, 
    isUpdating, 
    updateError, 
    applyUpdate, 
    dismissUpdate 
  } = useUpdateManager();

  if (!isUpdateAvailable) return null;

  return (
    <div className="fixed top-4 right-4 z-50 max-w-sm">
      <div className="bg-blue-50 border-2 border-blue-400 shadow-lg rounded-lg p-4 animate-in slide-in-from-right">
        <div className="flex items-start gap-3">
          <div className="bg-blue-100 p-2 rounded-full">
            <Download className="h-5 w-5 text-blue-600" />
          </div>
          
          <div className="flex-1">
            <h3 className="text-blue-800 font-medium text-sm">Update Available</h3>
            <p className="text-blue-700 text-xs mt-1">
              A new version of the app is ready to install.
            </p>
            
            {updateError && (
              <p className="text-red-600 text-xs mt-1">
                {updateError}
              </p>
            )}
            
            <div className="flex gap-2 mt-3">
              <Button
                onClick={applyUpdate}
                disabled={isUpdating}
                size="sm"
                className="text-xs h-7 px-2"
              >
                {isUpdating ? (
                  <>
                    <RefreshCw className="h-3 w-3 mr-1 animate-spin" />
                    Updating...
                  </>
                ) : (
                  'Update Now'
                )}
              </Button>
              
              <Button
                onClick={dismissUpdate}
                variant="outline"
                size="sm"
                className="text-xs h-7 px-2"
                disabled={isUpdating}
              >
                Later
              </Button>
            </div>
          </div>
          
          <button 
            onClick={dismissUpdate}
            className="text-blue-600 hover:text-blue-800 transition-colors"
            disabled={isUpdating}
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
